module.exports = __webpack_public_path__ + "img/shareWhite.453cfa17.svg";